import React from "react";
import {
  ClickAwayListener,
  Grow,
  IconButton,
  List,
  Paper,
  Popper,
} from "@mui/material";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";

import { FilterGroup } from "../../services/Alert";
import { FilterGroupListItem } from "./FilterGroupListItem";
import { ActionTooltip } from "../../components/Tooltips";

export const FilterGroupList = ({
  groups,
  onChange,
  onDelete,
  onUpdate,
  selectedGroup,
}: {
  groups: FilterGroup[];
  onChange: (filterGroup: FilterGroup) => void;
  onDelete: (group: FilterGroup) => void;
  onUpdate: () => void;
  selectedGroup: FilterGroup;
}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleGroupSelection = (group: FilterGroup) => {
    onChange(group);
    setOpen(false);
  };

  return (
    <>
      <ActionTooltip title={"FAVORITE_FILTER_INFO"}>
        <IconButton
          sx={{ color: "text.accentInverted" }}
          size={"small"}
          ref={anchorRef}
          onClick={() => setOpen((prevOpen) => !prevOpen)}
        >
          <FormatAlignLeftIcon fontSize="small" />
        </IconButton>
      </ActionTooltip>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        transition
        style={{ zIndex: 99 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <List dense={true}>
                  {groups.map((group) => (
                    <FilterGroupListItem
                      key={group.id}
                      group={group}
                      onChange={onUpdate}
                      onDelete={onDelete}
                      onSelect={handleGroupSelection}
                      selected={selectedGroup?.id === group.id}
                    />
                  ))}
                </List>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
